(() => {
 'use strict';
 if (window.yndEditorialUtilities) { window.yndEditorialUtilities(); return; }
 const key = 'ynd.saved-editorial-styles.v1';
 const catalog = new Map();
 const openers = new WeakMap();
 let saved = new Set();
 let persistent = true;
 const retiredStyles = new Set(['ynd-womens-oversized-acid-wash-hoodie', 'ynd-mens-oversized-acid-wash-hoodie']);
 const ids = value => Array.isArray(value) ? value.filter(id => typeof id === 'string' && id.length > 0 && !retiredStyles.has(id)) : [];
 try { saved = new Set(ids(JSON.parse(localStorage.getItem(key) || '[]'))); } catch { persistent = false; }
 const announce = text => {
  const status = document.querySelector('#ynd-favorites-dialog[open] [data-favorites-status]') || document.getElementById('ynd-save-status');
  if (status) status.textContent = text;
 };
 const notifyOverlay = () => {
  document.documentElement.classList.toggle('ynd-utility-is-open', Boolean(document.querySelector('.utility-dialog[open]')));
  document.dispatchEvent(new Event('ynd:overlay'));
 };
 const openRecovery = () => {
  if (location.hash !== '#recover') return;
  const recovery = document.getElementById('recover');
  if (recovery) { recovery.open = true; recovery.querySelector('input[type="email"]')?.focus({preventScroll:true}); }
 };
 function readCatalog() {
  catalog.clear();
  const add = (product, id) => {
   if (!product || typeof product.id !== 'string' || !product.id || (id && id !== product.id) || typeof product.title !== 'string' || !product.title || typeof product.url !== 'string' || !product.url.startsWith('/') || product.url.startsWith('//')) return;
   if (retiredStyles.has(product.id)) return;
   catalog.set(product.id, product);
  };
  try {
   const products = JSON.parse(document.getElementById('ynd-saved-catalog')?.textContent || '[]');
   if (Array.isArray(products)) products.forEach(product => add(product));
  } catch {}
  document.querySelectorAll('[data-saved-style]').forEach(card => {
   try { add(JSON.parse(card.querySelector('[data-saved-product]')?.textContent || 'null'), card.dataset.savedStyle); } catch {}
  });
 }
 function updateNote() {
  const note = document.getElementById('ynd-favorites-note');
  if (note) note.textContent = persistent
   ? 'Saved in this browser only. They won’t sync with your account or other devices.'
   : 'Browser storage is unavailable. Saved styles will last only while this page is open.';
 }
 function writeSaved() {
  try { localStorage.setItem(key, JSON.stringify([...saved])); } catch { persistent = false; }
  updateNote();
 }
 function updateButtons() {
  document.querySelectorAll('[data-saved-style]').forEach(card => {
   const id = card.dataset.savedStyle, style = catalog.get(id), button = card.querySelector('[data-save-style]');
   if (!button) return;
   button.setAttribute('aria-pressed', String(saved.has(id)));
   if (style) button.setAttribute('aria-label', `${saved.has(id) ? 'Unsave' : 'Save'} ${style.title}`);
   button.title = saved.has(id) ? 'Remove saved style' : 'Save style';
  });
  document.querySelectorAll('[data-favorite-count]').forEach(count => {
   count.textContent = String(saved.size); count.hidden = saved.size === 0;
  });
 }
 function renderSaved() {
  const dialog = document.getElementById('ynd-favorites-dialog');
  const list = dialog?.querySelector('[data-favorites-list]');
  if (!list) return;
  list.replaceChildren();
  const empty = dialog.querySelector('[data-favorites-empty]');
  if (empty) empty.hidden = saved.size > 0;
  saved.forEach(id => {
   const style = catalog.get(id);
   const row = document.createElement('article'); row.className = 'saved-style-row';
   if (style?.image) {
    const image = document.createElement('img'); image.src = style.image; image.alt = style.alt || style.title; image.width = 76; image.height = 96; row.append(image);
   } else {
    const placeholder = document.createElement('span'); placeholder.className = 'saved-style-placeholder'; placeholder.setAttribute('aria-hidden', 'true'); placeholder.textContent = 'YND'; row.append(placeholder);
   }
   const copy = document.createElement('div'), title = document.createElement('h3'), detail = document.createElement('p');
   if (style) {
    const link = document.createElement('a'); link.textContent = style.title; link.href = style.url; title.append(link);
    detail.textContent = style.held ? 'Style preview · availability to be confirmed' : 'Saved from the YND wardrobe';
   } else {
    title.textContent = 'Saved style';
    detail.textContent = 'Details aren’t available on this page.';
   }
   copy.append(title, detail);
   const remove = document.createElement('button'); remove.type = 'button'; remove.dataset.removeSavedStyle = id; remove.setAttribute('aria-label', `Remove ${style?.title || 'saved style'}`);
   const icon = dialog.querySelector('[data-close-utility] svg');
   if (icon) remove.append(icon.cloneNode(true)); else remove.textContent = 'Remove';
   row.append(copy, remove); list.append(row);
  });
 }
 function refresh() { readCatalog(); updateButtons(); renderSaved(); updateNote(); openRecovery(); }
 window.yndEditorialUtilities = refresh;
 document.addEventListener('click', event => {
  const target = event.target instanceof Element ? event.target : null;
  if (!target) return;
  const save = target.closest('[data-save-style]');
  if (save) {
   const card = save.closest('[data-saved-style]');
   if (!card || save.disabled) return;
   readCatalog();
   const id = card.dataset.savedStyle, style = catalog.get(id);
   if (!style) { announce('This style’s details aren’t available. Please reload the page and try again.'); return; }
   if (saved.has(id)) saved.delete(id); else saved.add(id);
   writeSaved(); updateButtons(); renderSaved();
   announce(`${style.title} ${saved.has(id) ? 'saved in this browser' : 'removed from saved styles'}.`);
   return;
  }
  const remove = target.closest('[data-remove-saved-style]');
  if (remove) {
   const id = remove.dataset.removeSavedStyle, title = catalog.get(id)?.title || 'Saved style';
   saved.delete(id); writeSaved(); updateButtons(); renderSaved(); announce(`${title} removed from saved styles.`);
   (document.querySelector('[data-favorites-list] button') || document.querySelector('[data-browse-styles]'))?.focus();
   return;
  }
  const trigger = target.closest('[data-open-utility]');
  if (trigger) {
   if (trigger.matches('a') && (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) return;
   const dialog = document.getElementById(trigger.dataset.openUtility);
   if (!dialog || typeof dialog.showModal !== 'function') return;
   event.preventDefault();
   openers.set(dialog, trigger.closest('#menu') ? document.getElementById('menu-toggle') : trigger);
   if (dialog.id === 'ynd-favorites-dialog') { readCatalog(); renderSaved(); }
   document.querySelectorAll('.utility-dialog[open]').forEach(other => { if (other !== dialog) other.close(); });
   if (!dialog.open) dialog.showModal();
   dialog.dispatchEvent(new CustomEvent('ynd:utility-open', {bubbles:true}));
   notifyOverlay();
   (dialog.querySelector('input:not([type="hidden"])') || dialog.querySelector('[data-close-utility]'))?.focus({preventScroll:true});
   return;
  }
  const close = target.closest('[data-close-utility], [data-browse-styles]');
  if (close) { close.closest('.utility-dialog')?.close(); return; }
  if (target.matches('.utility-dialog')) {
   const box = target.getBoundingClientRect();
   if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) target.close();
  }
 });
 // Native dialog containment can hand focus to browser chrome at its boundaries.
 // Wrap plain Tab locally; leave Ctrl/Alt/Meta browser shortcuts untouched.
 document.addEventListener('keydown', event => {
  if (event.key !== 'Tab' || event.ctrlKey || event.altKey || event.metaKey || event.defaultPrevented) return;
  const dialogs = [...document.querySelectorAll('.utility-dialog[open]')];
  const dialog = dialogs[dialogs.length - 1];
  if (!dialog) return;
  const active = document.activeElement;
  const activeDialog = active?.closest?.('dialog[open]');
  if (activeDialog && activeDialog !== dialog) return;
  const focusable = [...dialog.querySelectorAll('a[href], area[href], button, input:not([type="hidden"]), select, textarea, summary, [tabindex], [contenteditable="true"]')].filter(element => {
   if (element.tabIndex < 0 || element.matches(':disabled') || element.getAttribute('aria-disabled') === 'true' || element.closest('[hidden], [inert], [aria-hidden="true"]') || !element.getClientRects().length) return false;
   const style = window.getComputedStyle(element);
   return style.visibility !== 'hidden' && style.visibility !== 'collapse' && style.display !== 'none';
  });
  if (!focusable.length) { event.preventDefault(); dialog.focus({preventScroll:true}); return; }
  const first = focusable[0], last = focusable[focusable.length - 1];
  if (!focusable.includes(active) || (event.shiftKey ? active === first : active === last)) {
   event.preventDefault();
   (event.shiftKey ? last : first).focus({preventScroll:true});
  }
 });
 document.addEventListener('close', event => {
  if (!event.target.matches?.('.utility-dialog')) return;
  notifyOverlay();
  const opener = openers.get(event.target);
  if (opener?.isConnected && !document.querySelector('.utility-dialog[open]')) opener.focus({preventScroll:true});
 }, true);
 document.addEventListener('shopify:section:load', refresh);
 document.addEventListener('shopify:section:unload', () => queueMicrotask(refresh));
 window.addEventListener('hashchange', openRecovery);
 window.addEventListener('storage', event => {
  if (event.key !== key && event.key !== null) return;
  try { saved = new Set(ids(JSON.parse(event.newValue || '[]'))); readCatalog(); updateButtons(); renderSaved(); } catch {}
 });
 refresh();
})();
